import { ColumnHeader } from './column-header.model';

export class QueryResult {

    Columns: Array<ColumnHeader>
    AmountPage: number
    Total:number;
    Rows: Array<any>
    Success : boolean
    Message : string;
}
